/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CustomerDataList
} from '../../model/customerDataList'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  UserCreateDataRequest
} from '../../model/userCreateDataRequest'
import type {
  UserReadData
} from '../../model/userReadData'
import type {
  UserReadDataList
} from '../../model/userReadDataList'
import type {
  UserRoleDescriptionAPIDataList
} from '../../model/userRoleDescriptionAPIDataList'
import type {
  UserRoleUpdateAPIDataRequest
} from '../../model/userRoleUpdateAPIDataRequest'
import type {
  UsersAdminTableDataRetrieveParams
} from '../../model/usersAdminTableDataRetrieveParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Lists all users for current customer
 */
export const userList = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<UserReadDataList>(
      {url: `/users/`, method: 'GET', signal
    },
      options);
    }
  

export const getUserListQueryKey = () => {
    return [`/users/`] as const;
    }

    
export const getUserListQueryOptions = <TData = Awaited<ReturnType<typeof userList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userList>>> = ({ signal }) => userList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userList>>, TError, TData> & { queryKey: QueryKey }
}

export type UserListQueryResult = NonNullable<Awaited<ReturnType<typeof userList>>>
export type UserListQueryError = unknown

export const useUserList = <TData = Awaited<ReturnType<typeof userList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUserListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userList>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userList>>> = ({ signal }) => userList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userList>>, TError, TData> & { queryKey: QueryKey }
}

export type UserListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userList>>>
export type UserListSuspenseQueryError = unknown

export const useUserListSuspense = <TData = Awaited<ReturnType<typeof userList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUserListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getUserListLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getUserListQueryKey(),
          queryFn: () => userList(),
        }).then(() => null));
      /**
 * Create a single user
 */
export const userCreate = (
    userCreateDataRequest: UserCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<UserReadData>(
      {url: `/users/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userCreateDataRequest
    },
      options);
    }
  


export const getUserCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreate>>, TError,{data: UserCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof userCreate>>, TError,{data: UserCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userCreate>>, {data: UserCreateDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  userCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserCreateMutationResult = NonNullable<Awaited<ReturnType<typeof userCreate>>>
    export type UserCreateMutationBody = UserCreateDataRequest
    export type UserCreateMutationError = unknown

    export const useUserCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreate>>, TError,{data: UserCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getUserCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets table data for all users along with their roles
 */
export const usersAdminTableDataRetrieve = (
    params: UsersAdminTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/users/admin/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getUsersAdminTableDataRetrieveQueryKey = (params: UsersAdminTableDataRetrieveParams,) => {
    return [`/users/admin/`, ...(params ? [params]: [])] as const;
    }

    
export const getUsersAdminTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof usersAdminTableDataRetrieve>>, TError = unknown>(params: UsersAdminTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersAdminTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersAdminTableDataRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersAdminTableDataRetrieve>>> = ({ signal }) => usersAdminTableDataRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersAdminTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type UsersAdminTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersAdminTableDataRetrieve>>>
export type UsersAdminTableDataRetrieveQueryError = unknown

export const useUsersAdminTableDataRetrieve = <TData = Awaited<ReturnType<typeof usersAdminTableDataRetrieve>>, TError = unknown>(
 params: UsersAdminTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersAdminTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUsersAdminTableDataRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUsersAdminTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof usersAdminTableDataRetrieve>>, TError = unknown>(params: UsersAdminTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersAdminTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersAdminTableDataRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersAdminTableDataRetrieve>>> = ({ signal }) => usersAdminTableDataRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersAdminTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type UsersAdminTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof usersAdminTableDataRetrieve>>>
export type UsersAdminTableDataRetrieveSuspenseQueryError = unknown

export const useUsersAdminTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof usersAdminTableDataRetrieve>>, TError = unknown>(
 params: UsersAdminTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersAdminTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUsersAdminTableDataRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getUsersAdminTableDataRetrieveLoader = (queryParamsOrFn: (UsersAdminTableDataRetrieveParams | ((params: Params) => UsersAdminTableDataRetrieveParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getUsersAdminTableDataRetrieveQueryKey(queryParams),
            queryFn: () => usersAdminTableDataRetrieve(queryParams),
          }).then(() => null);
        });
      /**
 * Updates table data for all user roles
 */
export const usersAdminTableDataUpdate = (
    userRoleUpdateAPIDataRequest: UserRoleUpdateAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/users/admin/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userRoleUpdateAPIDataRequest
    },
      options);
    }
  


export const getUsersAdminTableDataUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersAdminTableDataUpdate>>, TError,{data: UserRoleUpdateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof usersAdminTableDataUpdate>>, TError,{data: UserRoleUpdateAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersAdminTableDataUpdate>>, {data: UserRoleUpdateAPIDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  usersAdminTableDataUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersAdminTableDataUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersAdminTableDataUpdate>>>
    export type UsersAdminTableDataUpdateMutationBody = UserRoleUpdateAPIDataRequest
    export type UsersAdminTableDataUpdateMutationError = unknown

    export const useUsersAdminTableDataUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersAdminTableDataUpdate>>, TError,{data: UserRoleUpdateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getUsersAdminTableDataUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * List user roles and their descriptions
 */
export const userRoleDescriptionsList = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<UserRoleDescriptionAPIDataList>(
      {url: `/users/admin/role-types/`, method: 'GET', signal
    },
      options);
    }
  

export const getUserRoleDescriptionsListQueryKey = () => {
    return [`/users/admin/role-types/`] as const;
    }

    
export const getUserRoleDescriptionsListQueryOptions = <TData = Awaited<ReturnType<typeof userRoleDescriptionsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRoleDescriptionsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserRoleDescriptionsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userRoleDescriptionsList>>> = ({ signal }) => userRoleDescriptionsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userRoleDescriptionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type UserRoleDescriptionsListQueryResult = NonNullable<Awaited<ReturnType<typeof userRoleDescriptionsList>>>
export type UserRoleDescriptionsListQueryError = unknown

export const useUserRoleDescriptionsList = <TData = Awaited<ReturnType<typeof userRoleDescriptionsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userRoleDescriptionsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUserRoleDescriptionsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserRoleDescriptionsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userRoleDescriptionsList>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userRoleDescriptionsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserRoleDescriptionsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userRoleDescriptionsList>>> = ({ signal }) => userRoleDescriptionsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userRoleDescriptionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type UserRoleDescriptionsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userRoleDescriptionsList>>>
export type UserRoleDescriptionsListSuspenseQueryError = unknown

export const useUserRoleDescriptionsListSuspense = <TData = Awaited<ReturnType<typeof userRoleDescriptionsList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userRoleDescriptionsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUserRoleDescriptionsListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getUserRoleDescriptionsListLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getUserRoleDescriptionsListQueryKey(),
          queryFn: () => userRoleDescriptionsList(),
        }).then(() => null));
      /**
 * Get current user
 */
export const usersMeRetrieve = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<UserReadData>(
      {url: `/users/me/`, method: 'GET', signal
    },
      options);
    }
  

export const getUsersMeRetrieveQueryKey = () => {
    return [`/users/me/`] as const;
    }

    
export const getUsersMeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof usersMeRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersMeRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersMeRetrieve>>> = ({ signal }) => usersMeRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type UsersMeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersMeRetrieve>>>
export type UsersMeRetrieveQueryError = unknown

export const useUsersMeRetrieve = <TData = Awaited<ReturnType<typeof usersMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUsersMeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUsersMeRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof usersMeRetrieve>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersMeRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersMeRetrieve>>> = ({ signal }) => usersMeRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type UsersMeRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof usersMeRetrieve>>>
export type UsersMeRetrieveSuspenseQueryError = unknown

export const useUsersMeRetrieveSuspense = <TData = Awaited<ReturnType<typeof usersMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUsersMeRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getUsersMeRetrieveLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getUsersMeRetrieveQueryKey(),
          queryFn: () => usersMeRetrieve(),
        }).then(() => null));
      /**
 * Lists all customers for current user
 */
export const userCustomerList = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CustomerDataList>(
      {url: `/users/me/customers`, method: 'GET', signal
    },
      options);
    }
  

export const getUserCustomerListQueryKey = () => {
    return [`/users/me/customers`] as const;
    }

    
export const getUserCustomerListQueryOptions = <TData = Awaited<ReturnType<typeof userCustomerList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCustomerList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserCustomerListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userCustomerList>>> = ({ signal }) => userCustomerList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userCustomerList>>, TError, TData> & { queryKey: QueryKey }
}

export type UserCustomerListQueryResult = NonNullable<Awaited<ReturnType<typeof userCustomerList>>>
export type UserCustomerListQueryError = unknown

export const useUserCustomerList = <TData = Awaited<ReturnType<typeof userCustomerList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCustomerList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUserCustomerListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUserCustomerListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userCustomerList>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCustomerList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserCustomerListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userCustomerList>>> = ({ signal }) => userCustomerList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCustomerList>>, TError, TData> & { queryKey: QueryKey }
}

export type UserCustomerListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userCustomerList>>>
export type UserCustomerListSuspenseQueryError = unknown

export const useUserCustomerListSuspense = <TData = Awaited<ReturnType<typeof userCustomerList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCustomerList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUserCustomerListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getUserCustomerListLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getUserCustomerListQueryKey(),
          queryFn: () => userCustomerList(),
        }).then(() => null));
      